export default function toAbsoluteURL(url) {
    if (url && url.indexOf('//') === 0 && !process.browser) { // protocol relative and server side
        return `http:${url}`;
    } else if (url && url.indexOf('//') === 0 && process.browser) {
        return `https:${url}`;
    }
    return url;
}



// WEBPACK FOOTER //
// ./app/lib/url-adapter/toAbsoluteURL.js